<script lang="ts">
  import { onMount } from 'svelte';
  import { ActionType, useDispatch } from './Store';

  const dispatch = useDispatch();

  let container: HTMLDivElement;
  let image: HTMLImageElement;

  const resizeObserver = new ResizeObserver(() => resizeEvent());
  const resizeEvent = () =>
    setTimeout(() => {
      if (!container) return;
      container.style.height = `${image?.height || 0}px`;
      if (document.body.clientWidth <= 600) container.style.marginTop = '4em';
      else container.style.marginTop = '';
    }, 0);

  onMount(() => {
    resizeObserver.observe(container);
    return () => resizeObserver.unobserve(container);
  });

  const handleClick = () => dispatch({ type: ActionType.toggleVideo });
</script>

<div bind:this={container} class="page-header header-filter clear-filter header-container" data-parallax="true">
  <img bind:this={image} src="assets/img/1.png" alt="Header" />
  <div id="video-box" on:click={() => handleClick()} />
</div>

<style>
  img {
    position: absolute;
    top: 0;
    width: 100%;
  }

  .header-container {
    background-position: top center;
  }

  #video-box {
    position: absolute;
    width: 37.2%;
    height: 38.4%;
    top: 33.8%;
    left: 56%;
    z-index: 2;
    cursor: pointer;
  }
</style>
